import React, { useState } from "react";
import CurrentUser from "./CurrentUser";
import Parametros from "./Parametros";

const EliminarElemento = ({ endpoint, method = "DELETE", onSuccess }) => {
  const [usuario] = useState(CurrentUser.user);

  const onClick = () => {
    if (window.confirm("¿Está seguro de eliminar el elemento?")) {
      fetch(Parametros.urlApi + endpoint, {
        method,
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          alert(data?.message || data?.detail);
          onSuccess?.();
        })
        .catch((err) => {
          alert("Error al eliminar el elemento");
        });
    }
  };

  return (
    <abbr title="Eliminar Elemento">
      <span
        style={{ cursor: "pointer" }}
        onClick={onClick}
        className="glyphicon glyphicon-remove"
      ></span>
    </abbr>
  );
};

export default EliminarElemento;
